const Vue = require('vue')
const guid = require('sci/helpers/guid')
const $ = require('jquery')
const R = require('ramda')
const elasticlunr = require('elasticlunr')
const S = require('string')

const stringify = (value) => {
    if (value !== null && value !== undefined) {
        return value.toString()
    }

    return value
}

const defaultFormat = (state) => state.text
const noop = (x) => x

const buildSelect2 = (engine, self, cb = null, values = []) => {
    const $select = $(self.$els.select)

    $select.empty()
    $select.unbind()

    for (const value of values) {
        $select.append(`<option selected value="${value[self.identifier]}">${value[self.display]}</option>`)
    }

    const extra = {}

    if (self.editable) {
        extra.tags = true
        extra.createTag = function (params) {
            const term = $.trim(params.term)

            if (term.length < 1) {
                return null
            }

            return {
                id: term,
                text: term,
                newTag: true
            }
        }
    }

    let cancelSearch = null

    let selected = []

    if (self.model !== null && Array.isArray(self.model)) {
        const valid = self.model.reduce((result, item) => {
            return result && item.hasOwnProperty(self.identifier)
        }, true)

        if (valid) {
            selected = self.model
        } else {
            console.error('form-multi-select(:model) must be an array of objects')
        }
    }

    const placeholder = {
        id: null,
        text: self.placeholder || 'Selecione...'
    }

    $select.prop('disabled', self.disabled)
        .select2({
            language: {
                errorLoading: function () {
                    return 'Os resultados não puderam ser carregados.'
                },
                inputTooLong: function (args) {
                    const overChars = args.input.length - args.maximum

                    let message = 'Apague ' + overChars + ' caracter'

                    if (overChars !== 1) {
                        message += 'es'
                    }

                    return message
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length

                    return 'Digite ' + remainingChars + ' ou mais caracteres'
                },
                loadingMore: function () {
                    return 'Carregando mais resultados…'
                },
                maximumSelected: function (args) {
                    let message = 'Você só pode selecionar ' + args.maximum + ' ite'

                    if (args.maximum === 1) {
                        message += 'm'
                    } else {
                        message += 'ns'
                    }

                    return message
                },
                noResults: function () {
                    return 'Nenhum resultado encontrado'
                },
                searching: function () {
                    return 'Buscando…'
                }
            },
            // initSelection: selected ? function (select, callback) {
            //     try {
            //         callback(selected.map((item) => {
            //             return {
            //                 id: item[self.identifier],
            //                 text: item[self.display],
            //                 original: item
            //             }
            //         }))
            //     } catch (e) {
            //         console.error(e)
            //     }
            // } : null,
            placeholder,
            multiple: true,
            tags: false,
            // dropdownParent: $select.closest('.__dropdown-holder'),
            id: guid(),
            theme: 'bootstrap',
            dropdownAutoWidth: true,
            width: 'auto',
            allowClear: self.allowEmpty,
            templateResult: (state, container) => {
                if (self.templateResult && self.templateResult !== defaultFormat) {
                    if (state.hasOwnProperty(self.identifier)) {
                        return self.templateResult(state.original, container)
                    }
                }

                return defaultFormat(state, container)
            },
            templateSelection: (state, container) => {
                if (self.templateSelection && self.templateSelection !== defaultFormat) {
                    if (state.hasOwnProperty(self.identifier)) {
                        return self.templateSelection(state.original, container)
                    }
                }

                return defaultFormat(state, container)
            },
            escapeMarkup: self.formatResult !== defaultFormat ? noop : undefined,
            ajax: {
                transport: function (params, success, failure) {
                    if (cancelSearch) {
                        clearTimeout(cancelSearch)
                    }

                    // Paraleliza a busca para evitar ui hang
                    cancelSearch = setTimeout(() => {
                        Promise.resolve().then(() => {
                            const term = params.data.term || ''

                            if (!term) {
                                return success(self.sort(self.options))
                            }

                            const searchResult = engine.search(S(term).latinise().s, {
                                fields: {
                                    text: {
                                        bool: 'AND',
                                        expand: true
                                    }
                                }
                            })

                            const result = searchResult.map(item => {
                                if (self.optionsIndex.hasOwnProperty(item.ref)) {
                                    return self.optionsIndex[item.ref]
                                }

                                return null
                            }).filter(_ => !!_)

                            success(result)
                        })
                    }, 1)
                },
                processResults: function (result, params) {
                    try {
                        let items = result

                        if (self.processResult) {
                            items = self.processResult(items, params.term || null)
                        }

                        items = items.map(item => {
                            if (item.hasOwnProperty('__auto')) {
                                return item
                            }

                            // item.original = Object.assign({}, item)
                            // item.text = item[self.display]
                            // item[self.identifier] = item[self.identifier]
                            // item.id = item[self.identifier]
                            // item.children = null

                            return {
                                id: item[self.identifier],
                                text: item[self.display],
                                original: Object.assign({}, item)
                            }
                        })
                        return {
                            results: items
                        }
                    } catch (e) {
                        console.error(e)

                        return null
                    }
                },
                cache: true
            },
            ...extra
        })

    if (cb) {
        $select.on('change', function () {
            cb.apply(this, arguments)
        })
    }

    $select.parent().on('blur', '.select2-search__field', function (evt) {
        const relatedTarget = evt.relatedTarget || document.activeElement

        setTimeout(() => {
            const holderDom = self.$els.holder
            const a = relatedTarget
            const b = a && holderDom.contains(a)

            if (!b) {
                $select.parent()
                    .find('.select2-selection.select2-selection--multiple')
                    .scrollTop(0)
            }
        }, 1)
    })
}

Vue.component('form-multi-select', {
    props: {
        label: {
            type: String
        },
        identifier: {
            type: String,
            default: 'id'
        },
        display: {
            type: String,
            default: 'name'
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        options: {
            default: [],
            type: Array
        },
        disabled: {
            default: false,
            type: Boolean
        },
        onChange: {
            default: null,
            type: Function
        },
        allowEmpty: {
            type: Boolean,
            default: true
        },
        templateResult: {
            type: Function,
            default: defaultFormat
        },
        templateSelection: {
            type: Function,
            default: defaultFormat
        },
        processResult: {
            type: Function,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        sorter: {
            type: Function,
            default: null
        }
    },
    watch: {
        disabled () {
            $(this.$els.select).prop('disabled', this.disabled)
        },
        options (newVal, oldVal) {
            this.reload()
        },
        model (newVal, oldVal) {
            this.reload()
        }
    },
    data () {
        return {
            optionsIndex: {},
            fieldName: '',
            currentValue: null
        }
    },
    methods: {
        sort (options) {
            if (this.sorter) {
                return this.sorter(options)
            } else {
                return R.sortBy(R.prop('$searchable'), options)
            }
        },
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        },
        holderClass () {
            return this.iconClass ? 'input-icon' : null
        },
        findById (id) {
            if (this.optionsIndex.hasOwnProperty(id)) {
                return this.optionsIndex[id]
            }

            return null
        },
        selectChanged: (self) => function () {
            const options = self.options
            const selected = $(this).select2('data')

            const actual = selected.map(function (item) {
                return options.filter(function (option) {
                    return stringify(option.id) === stringify(item.id)
                }).shift()
            })

            const added = actual.filter(function (item) {
                return !self.currentValue.filter(function (anotherItem) {
                    return stringify(anotherItem.id) === stringify(item.id)
                }).shift()
            })

            const removed = self.currentValue.filter(function (item) {
                return !actual.filter(function (anotherItem) {
                    return stringify(anotherItem.id) === stringify(item.id)
                }).shift()
            })

            const diff = { removed, added, actual }

            self.currentValue = actual
            self.model = actual

            if (self.onChange) {
                self.onChange(diff)
            }
        },
        reload () {
            this.currentValue = this.model

            this.optionsIndex = (this.options || []).reduce((obj, item) => {
                item.$searchable = S(item[this.display]).latinise().s

                const id = String(item[this.identifier])

                obj[id] = item

                return obj
            }, {})

            this.buildEngine().then((engine) => {
                buildSelect2(engine, this, this.selectChanged(this), this.model)
            })
        },
        buildEngine () {
            const self = this

            return Promise.resolve().then(() => {
                this.engine = elasticlunr(function () {
                    this.addField('text')

                    this.setRef('id');

                    (self.options || []).forEach((item) => {
                        this.addDoc({
                            text: S(item[self.display]).latinise().s,
                            id: item[self.identifier]
                        })
                    })
                })

                return this.engine
            })
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }
        this.reload()
    },
    template: `
            <div class="form-group" v-el:holder>
                <form-label v-if="hasLabel()" :hint="getHint()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <div class="__dropdown-holder" style="position: relative">
                    <select
                            multiple
                            class="form-control"
                            v-el:select
                            v-bind:data-field="fieldName"
                            v-bind:disabled="disabled">
                            <option v-if="allowEmpty" value=""></option>
                    </select>
                </div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/multi-select.js